import React from 'react';
import './NoQuestionsMessage.css';

export interface NoQuestionsMessageProps {
    selectedBook: string;
    selectedChapter: string;
    selectedQuestionType: 'true_false' | 'multiple_choice';
}

const NoQuestionsMessage: React.FC<NoQuestionsMessageProps> = ({
    selectedBook,
    selectedChapter,
    selectedQuestionType
}) => {
    return (
        <div className="content-panel no-questions">
            <div className="no-questions-icon">📚</div>
            <h2 className="no-questions-title">No Questions Found</h2>
            <p className="no-questions-message">
                No questions are available for the selected filters. Try adjusting your selection to see more questions.
            </p>
            <div className="no-questions-filters">
                <span className="content-badge">Book: {selectedBook}</span>
                <span className="content-badge">
                    Chapter: {selectedChapter === 'all' ? 'All Chapters' : `Chapter ${selectedChapter}`}
                </span>
                <span className="content-badge">
                    Type: {selectedQuestionType === 'true_false' ? 'True/False' : 'Multiple Choice'}
                </span>
            </div>
        </div>
    );
};

export default NoQuestionsMessage; 